import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import CommandPalette from "./CommandPalette";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

const SIDEBAR_KEY = "cas-sidebar-collapsed";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(SIDEBAR_KEY) === "1"; } catch { return false; }
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const [cmdk, setCmdk] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed((value) => {
      const next = !value;
      try { localStorage.setItem(SIDEBAR_KEY, next ? "1" : "0"); } catch { /* ignore */ }
      return next;
    });
  };

  return (
    <TooltipProvider delayDuration={250}>
      <div className="min-h-screen">
        {mobileOpen && (
          <button
            type="button"
            className="fixed inset-0 z-20 bg-black/55 lg:hidden"
            aria-label="Close navigation"
            onClick={() => setMobileOpen(false)}
          />
        )}
        <Sidebar
          collapsed={collapsed}
          onToggle={toggleCollapsed}
          mobileOpen={mobileOpen}
          onNavigate={() => setMobileOpen(false)}
        />
        <div className={`min-h-screen min-w-0 ${collapsed ? "lg:ml-[68px]" : "lg:ml-[260px]"} transition-[margin] duration-200`}>
          <Topbar onOpenCmdk={() => setCmdk(true)} onOpenNav={() => setMobileOpen(true)} />
          <main className="p-4 sm:p-6 lg:p-8 min-w-0">
            <Outlet />
          </main>
        </div>
        <CommandPalette open={cmdk} onOpenChange={setCmdk} />
        <Toaster theme="dark" position="top-right" toastOptions={{
          style: { background: "rgba(20,20,42,0.92)", color: "#fff", border: "1px solid rgba(255,255,255,0.08)", backdropFilter: "blur(20px)" }
        }} />
      </div>
    </TooltipProvider>
  );
}
